import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../utils/i18n';
import iconBlock from '@adsk/bim360-matrix-react-assets/icon-block.svg';
import iconCheck from '@adsk/bim360-matrix-react-assets/icon-check.svg';
import IssueRootCausesAdminStatus from './IssueRootCausesAdminStatus';
import {ISSUE_ROOT_CAUSES_STATUS_TYPES} from '../../../constants/issue-root-causes';
import SelectBoxAdapter from '../../common/SelectBoxAdapter';

export default class IssueRootCauseStatusDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.issueRootCausesStatuses = [
      IssueRootCauseStatusDropdown.IssueRootCausesStatuses.ACTIVE,
      IssueRootCauseStatusDropdown.IssueRootCausesStatuses.INACTIVE
    ];
  }

  _dropdownItemRenderer(val) {
    const isActive = val === ISSUE_ROOT_CAUSES_STATUS_TYPES.ACTIVE;
    return <IssueRootCausesAdminStatus isActive={isActive} />;
  }

  render() {
    return (
      <SelectBoxAdapter
        className="IssueRootCauseStatusDropdown"
        options={this.issueRootCausesStatuses}
        onChange={this.props.onChange}
        selectedOptions={this.props.selected}
        optionRenderer={this._dropdownItemRenderer}
        valueRenderer={this._dropdownItemRenderer}
        disabled={this.props.disabled}
      />
    );
  }
}

IssueRootCauseStatusDropdown.displayName = 'IssueRootCauseStatusDropdown';

IssueRootCauseStatusDropdown.IssueRootCausesStatuses = {
  ACTIVE: {
    label: i18n.t('issueRootCauses.statuses.active'),
    value: ISSUE_ROOT_CAUSES_STATUS_TYPES.ACTIVE,
    icon: iconCheck
  },
  INACTIVE: {
    label: i18n.t('issueRootCauses.statuses.inactive'),
    value: ISSUE_ROOT_CAUSES_STATUS_TYPES.INACTIVE,
    icon: iconBlock
  }
};

IssueRootCauseStatusDropdown.defaultProps = {
  selected: IssueRootCauseStatusDropdown.IssueRootCausesStatuses.ACTIVE
};

IssueRootCauseStatusDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.object,
  disabled: PropTypes.bool
};
